interface FeedRestoreSnapshot {
  status: 'pending' | 'success' | 'error'
  data?: { pages: ReadonlyArray<{ next_cursor?: string | null }> }
}

/** Готов только DOM текущего query, а не сохранённый снимок старого observer. */
export function feedRestoring(
  cache: FeedRestoreSnapshot | undefined, observer: FeedRestoreSnapshot, targetPages: number,
): boolean {
  if (!cache || cache.status !== observer.status) return true
  if (cache.status === 'error') return false
  if (cache.status !== 'success' || !cache.data || cache.data !== observer.data) return true
  const pages = cache.data.pages
  return pages.length < targetPages && Boolean(pages.at(-1)?.next_cursor)
}
